import { Row, Col } from 'react-bootstrap';
import { useIntl, FormattedMessage } from 'react-intl';
import { useGeneralInformation } from './useGeneralInformation';
import '../../../../css/DppWidget.css';

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '12px 0', borderTop: '1px solid #f0f0f0', gap: '12px' }}>
      <span style={{ fontSize: '14px', color: '#909090', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.6px', flexShrink: 0 }}>
        {label}
      </span>
      <span style={{ fontSize: '14px', color: '#333', fontWeight: 500, textAlign: 'right', wordBreak: 'break-word' }}>
        {value}
      </span>
    </div>
  );
};

const TechnicalDataWidget = ({ submodel }) => {
  const intl = useIntl();
  const locale = intl.locale;
  const general = useGeneralInformation(submodel, locale);

  return (
    <div className="dpp-widget">
      <Row className="g-0">

        {/* LEFT: Title + Product Image */}
        <Col lg={12} xl={6} className="p-4 p-xl-5 d-flex flex-column">
          <h2 className="dpp-widget-title mb-4">
            <FormattedMessage id="technicalData.title" defaultMessage="General Information" />
          </h2>

          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '16px',
              padding: '20px',
              minHeight: '180px',
            }}
          >
            {general.productImage ? (
              <img
                src={general.productImage}
                alt="Product"
                className="img-fluid"
                style={{ maxHeight: '260px', objectFit: 'contain' }}
              />
            ) : (
              <small className="text-muted">No image available</small>
            )}
          </div>
        </Col>

        {/* RIGHT: Manufacturer logo + Info rows */}
        <Col lg={12} xl={6} className="p-4 p-xl-5 d-flex flex-column justify-content-center">

          {general.manufacturerLogo && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '14px',
                background: '#fff',
                borderRadius: '12px',
                marginBottom: '20px',
              }}
            >
              <img src={general.manufacturerLogo} alt="Manufacturer Logo" style={{ maxHeight: '68px', maxWidth: '100%', objectFit: 'contain' }} />
            </div>
          )}

          <div>
            <InfoRow
              label={intl.formatMessage({ id: 'technicalData.generalInformation.manufacturer', defaultMessage: 'Manufacturer' })}
              value={general.manufacturerName || '—'}
            />
            <InfoRow
              label={intl.formatMessage({ id: 'technicalData.generalInformation.productDesignation', defaultMessage: 'Product' })}
              value={general.productDesignation || '—'}
            />
            <InfoRow
              label={intl.formatMessage({ id: 'technicalData.generalInformation.articleNumber', defaultMessage: 'Article No.' })}
              value={general.articleNumber || '—'}
            />
            {general.orderCode && (
              <InfoRow
                label={intl.formatMessage({ id: 'technicalData.generalInformation.orderCode', defaultMessage: 'Order Code' })}
                value={general.orderCode}
              />
            )}
          </div>
        </Col>

      </Row>
    </div>
  );
};

export default TechnicalDataWidget;
